import { values } from '@fortem-monorepo/js-utilities';
export const PRICE_TYPE = {
    Notional: 'notional',
    NotionalFlat: 'notionalflat',
    Unit: 'unit',
    UnitLev: 'unitlev',
    Etf: 'etf',
};
export const PRICE_TYPES = values(PRICE_TYPE);
